
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stream-2-product-page",
      function () {
        return require("private-next-pages/stream-2-product-page/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stream-2-product-page"])
      });
    }
  